import React from 'react'
import { Container, Typography, Button, Grid } from '@material-ui/core'
import { withRouter } from 'react-router-dom'

const style = {
   paper: {
      marginTop: 8,
      display: 'flex',
      flexDirection: 'column',
      align: 'center',
      width: '450px'
   },
   leftside: {
      backgroundColor: '#004B93',
      width: '100%',
      height: '100%',
      marginTop: 8,
      display: 'flex',
      flexDirection: 'column',
      align: 'center'
   }
}

const NoMatchPage = props => {
   const gotoLoginBtn = e => {
      e.preventDefault()
      props.history.push('/')
   }

   return (
      <Grid container spacing={0} style={{ height: '100%', margin: 0 }}>
         <Grid item xs={12} sm={6} md={6}>
            <Container maxWidth="xs" justify="center">
               <div style={style.paper}>
                  <Typography
                     component="h1"
                     variant="h5"
                     style={{ color: '#124387', marginTop: 100 }}
                  >
                     <b>Página no encontrada en Mutual SER</b>
                  </Typography>
               </div>
               <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  style={style.submit}
                  onClick={gotoLoginBtn}
               >
                  Ir al login
               </Button>
            </Container>
         </Grid>
         <Grid item xs={12} sm={6} md={6}>
            <div
               style={{
                  marginTop: '20%',
                  color: 'white',
                  fontSize: '16px',
                  padding: '16px 32px',
                  position: 'absolute',
                  zIndex: 4
               }}
            >
               <Container maxWidth="xs" justify="center">
                  <Typography variant="h1" gutterBottom>
                     404
                  </Typography>
                  <Typography
                     component="h1"
                     variant="h5"
                     style={{ color: '#ffffff' }}
                  >
                     Página Web no encontrada
                  </Typography>
               </Container>
            </div>
            <div style={{ position: 'relative' }}>
               <img
                  alt="nurse"
                  src="/static/nurse.png"
                  style={{ width: '100%', height: 'auto' }}
               />
               <div
                  style={{
                     position: 'absolute' /* Sit on top of the page content */,
                     display: 'block' /* Hidden by default */,
                     width: '100%' /* Full width (cover the whole page) */,
                     height: '100%' /* Full height (cover the whole page) */,
                     top: 0,
                     left: 0,
                     right: 0,
                     bottom: 0,
                     background:
                        'linear-gradient(to bottom left, #3333cc 0%, #6699ff 100%)',
                     opacity: 0.6,
                     zIndex: 2 /* Specify a stack order in case you're using a different order for other elements */
                  }}
               />
            </div>
         </Grid>
      </Grid>
   )
}

export default withRouter(NoMatchPage)
